import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import {
  Button,
  PageHeader,
  Result,
  Skeleton,
  Descriptions,
  Typography
} from 'antd';
import history from '@utils/history';
import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';
import EditProperty from './EditProperty';
import PricingSummary from '@components/PricingSummary';
import RegionChart from '../Regions/chart';

const { Title } = Typography;

import './ViewProperty.less';

function ViewPropertyPage(props) {
  const {
    loadig,
    loadProperty,
    resetProperty,
    basicInfo,
    serviceInfo,
    activeSetting,
    serviceInfo: { regionHours },
    match: { params, url }
  } = props;

  const { id: propertyId } = params || {};

  if (!propertyId) {
    return (
      <div className="properties main-page">
        <PageHeader
          title="Property"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="property main-content">
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        </div>
      </div>
    );
  }

  const renderProperty = () => {
    const {
      name,
      address,
      city: cityState,
      state,
      zipcode,
      buildingsNames,
      bedroomsCounts,
      unitsCount
    } = basicInfo;
    const {
      status,
      office,
      region,
      activeAt,
      firstDayOfService,
      keyReleaseEmail,
      scheduleEmail,
      keyRelease
    } = serviceInfo;

    const citySplits = (cityState || ' _ ').split('_');
    const city = citySplits[0];

    const { label: officeName } = office || {};
    const { name: regionName, timezone } = region || {};

    return (
      <div className="properties main-page">
        <PageHeader
          title={name}
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        >
          <div
            className="content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '60%'
              }}
            >
              <Descriptions size="small" column={3}>
                <Descriptions.Item label="Address">
                  {address}, {city}, {state}, {zipcode}
                </Descriptions.Item>
                <Descriptions.Item label="Office">
                  {officeName}
                </Descriptions.Item>

                <Descriptions.Item label="Status">{status}</Descriptions.Item>
              </Descriptions>
            </div>
            <div className="extra">
              <Button
                key="1"
                type="primary"
                onClick={() => history.push(`${url}/edit`)}
              >
                Edit
              </Button>
            </div>
          </div>
        </PageHeader>

        <div
          className="main-content property"
          style={{
            flexDirection: 'column'
          }}
        >
          <div
            className="content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <Descriptions bordered column={1} style={{ width: '60%' }}>
              <Descriptions.Item label="Region" span={2}>
                {regionName}
              </Descriptions.Item>
              <Descriptions.Item label="Timezone" span={2}>
                {timezone}
              </Descriptions.Item>
              <Descriptions.Item label="Units Count">
                {unitsCount}
              </Descriptions.Item>
              <Descriptions.Item label="Bedroom Counts">
                {(bedroomsCounts || []).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Buildings" span={2}>
                {(buildingsNames || []).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Active" span={2}>
                {activeAt && activeAt.format ? activeAt.format('LLL') : ''}
              </Descriptions.Item>
              <Descriptions.Item label="First day of Service" span={2}>
                {firstDayOfService && firstDayOfService.format
                  ? firstDayOfService.format('LLL')
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label="Key Release Email" span={4}>
                {(keyReleaseEmail || []).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Schedule Email" span={4}>
                {(scheduleEmail || []).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Key Release" span={4}>
                {keyRelease}
              </Descriptions.Item>
            </Descriptions>
            <div style={{ margin: '0 auto' }}>
              <RegionChart data={regionHours} />
            </div>
          </div>
          <div className="pricing-summary">
            <div>
              <Title level={4}>Current Pricing</Title>
            </div>
            {activeSetting && <PricingSummary pricingData={activeSetting} />}
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    loadProperty(propertyId);

    return () => {
      resetProperty();
    };
  }, [propertyId]);

  if (loadig) {
    return (
      <div className="properties main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="property main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  return (
    <Switch>
      <Route exact path={`${url}/`}>
        {renderProperty()}
      </Route>
      <Route exact path={`${url}/edit`}>
        <EditProperty />
      </Route>
    </Switch>
  );
}

ViewPropertyPage.propTypes = {
  match: PropTypes.object,
  loadProperty: PropTypes.func,
  resetProperty: PropTypes.func,
  loadig: PropTypes.bool,
  basicInfo: PropTypes.object,
  serviceInfo: PropTypes.object,
  activeSetting: PropTypes.object,
  regionHours: PropTypes.object
};

const mapStateToProps = state => ({
  loadig: PropertySelectors.selectIsLoading(state),
  basicInfo: PropertySelectors.selectBasicInfo(state),
  serviceInfo: PropertySelectors.selectMoreInfo(state),
  activeSetting: PropertySelectors.selectActiveSetting(state)
});

const mapDispatchToProps = dispatch => ({
  loadProperty: step => {
    dispatch(PropertyActions.loadPropertyRequest(step));
  },
  resetProperty: () => dispatch(PropertyActions.resetProperty())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewPropertyPage);
